function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "100819_Current",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "prysm-screen-v2",
  transform: "translate(-112.000000, -1325.000000)",
  fill: "#7E7670",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(112.000000, 1325.000000)"
}, React.createElement("path", {
  d: "M27.625,26.5625 C27.625,20.465875 23.649125,15.28725 18.1570625,13.4608125 C20.0270625,12.10825 21.25,9.91525 21.25,7.4375 C21.25,3.3373125 17.9126875,0 13.8125,0 C9.7123125,0 6.375,3.3373125 6.375,7.4375 C6.375,9.91525 7.5979375,12.10825 9.4679375,13.4608125 C3.975875,15.28725 0,20.465875 0,26.5625 L0,27.625 L27.625,27.625 L27.625,26.5625 Z M8.5,7.4375 C8.5,4.5081875 10.8831875,2.125 13.8125,2.125 C16.7418125,2.125 19.125,4.5081875 19.125,7.4375 C19.125,10.3668125 16.7418125,12.75 13.8125,12.75 C10.8831875,12.75 8.5,10.3668125 8.5,7.4375 Z M2.1728125,25.5 C2.7115,19.5510625 7.7254375,14.875 13.8125,14.875 C19.8995625,14.875 24.9135,19.5510625 25.4521875,25.5 L2.1728125,25.5 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M41.5320625,36.8358125 C43.4020625,35.48325 44.625,33.29025 44.625,30.8125 C44.625,26.7123125 41.2876875,23.375 37.1875,23.375 C33.0873125,23.375 29.75,26.7123125 29.75,30.8125 C29.75,33.29025 30.9729375,35.48325 32.8429375,36.8358125 C27.350875,38.66225 23.375,43.840875 23.375,49.9375 L23.375,51 L51,51 L51,49.9375 C51,43.840875 47.024125,38.66225 41.5320625,36.8358125 Z M31.875,30.8125 C31.875,27.8831875 34.2581875,25.5 37.1875,25.5 C40.1168125,25.5 42.5,27.8831875 42.5,30.8125 C42.5,33.7418125 40.1168125,36.125 37.1875,36.125 C34.2581875,36.125 31.875,33.7418125 31.875,30.8125 Z M25.5478125,48.875 C26.0865,42.9260625 31.1004375,38.25 37.1875,38.25 C43.2745625,38.25 48.2885,42.9260625 48.8271875,48.875 L25.5478125,48.875 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "38.25 19.125 38.25 6.375 29.127375 6.375 32.6261875 2.8761875 31.1238125 1.3738125 25.060125 7.4375 31.1238125 13.5011875 32.6261875 11.9988125 29.127375 8.5 36.125 8.5 36.125 19.125"
}), React.createElement("polygon", {
  id: "Path",
  points: "11.9988125 39.0011875 15.497625 42.5 8.5 42.5 8.5 31.875 6.375 31.875 6.375 44.625 15.497625 44.625 11.9988125 48.1238125 13.5011875 49.6261875 19.564875 43.5625 13.5011875 37.4988125"
}))));

var SvgDevelopment = function SvgDevelopment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDevelopment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/development.28526840.svg";
export { ForwardRef as ReactComponent };